<template>
  <div class="dashboard-tab">
    <!-- Statistics Cards -->
    <b-row>
      <b-col xl="4" lg="4" md="6" sm="12" class="mb-1">
        <div class="stat-card">
          <div class="stat-number">
            {{ dashboardStats.totalReviewers || 0 }}
          </div>
          <div class="stat-label">Total Reviewers</div>
        </div>
      </b-col>

      <b-col xl="4" lg="4" md="6" sm="12" class="mb-1">
        <div class="stat-card">
          <div class="stat-number">
            {{ dashboardStats.totalReviewees || 0 }}
          </div>

          <div class="stat-label">Total Reviewees</div>
        </div>
      </b-col>

      <b-col xl="4" lg="4" md="6" sm="12" class="mb-1">
        <div class="stat-card">
          <div class="stat-number">{{ dashboardStats.totalSurveys || 0 }}</div>
          <div class="stat-label">Total Surveys</div>
        </div>
      </b-col>
    </b-row>

    <!-- No Results Message -->
    <div
      v-if="!resultData.data || resultData.data.length === 0"
      class="text-center py-5"
    >
      <feather-icon icon="AlertCircleIcon" size="48" class="text-muted mb-3" />
      <h5 class="text-muted">NO RESULTS AVAILABLE</h5>
      <p class="text-muted">
        There are no results for this record. Please try a different selection.
      </p>
    </div>

    <!-- Charts Row -->
    <b-row v-else>
      <b-col xl="6" lg="6" md="12" class="mb-3">
        <b-card>
          <b-card-header>
            <h5 class="mb-0">
              <feather-icon icon="BarChart3Icon" size="18" class="mr-2" />
              Success Rates by Sections (%)
            </h5>
          </b-card-header>
          <b-card-body class="p-1">
            <div class="chart-container" ref="percentageChartContainer">
              <percentage-chart
                ref="percentageChart"
                :key="`percentage-chart-${chartKey}`"
                :chart-data="resultData"
              />
            </div>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col xl="6" lg="6" md="12" class="mb-3">
        <b-card>
          <b-card-header>
            <h5 class="mb-0">
              <feather-icon icon="BarChartIcon" size="18" class="mr-2" />
              Success Rates by Sections (Count)
            </h5>
          </b-card-header>
          <b-card-body class="p-1">
            <div class="chart-container" ref="countChartContainer">
              <count-chart
                ref="countChart"
                :key="`count-chart-${chartKey}`"
                :chart-data="resultData"
              />
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import PercentageChart from "./charts/PercentageChart.vue";
import CountChart from "./charts/CountChart.vue";

export default {
  name: "DashboardTab",
  components: {
    PercentageChart,
    CountChart,
  },
  props: {
    resultData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      chartKey: 0,
    };
  },
  activated() {
    // Tab'a geri dönüldüğünde chart'ları yeniden render et
    this.chartKey += 1;
  },
  watch: {
    resultData: {
      deep: true,
      handler() {
        // Data değiştiğinde chart'ları yeniden render et
        this.chartKey += 1;
      },
    },
  },
  computed: {
    dashboardStats() {
      if (!this.resultData.data || !Array.isArray(this.resultData.data)) {
        return {
          totalReviewers: 0,
          totalReviewees: 0,
          totalSurveys: 0,
          averageScore: "0%",
          passedCount: 0,
          failedCount: 0,
          pendingCount: 0,
        };
      }

      const uniqueReviewers = new Set();
      const uniqueReviewees = new Set();
      let passedCount = 0;
      let failedCount = 0;
      let pendingCount = 0;
      let totalScore = 0;
      let scoreCount = 0;


      this.resultData.data.forEach((item) => {
        // Add reviewer and reviewee names
        if (item.reviewer_name) {
          uniqueReviewers.add(item.reviewer_name);
        }

        // Add reviewee name
        if (item.reviewee_name) {
          uniqueReviewees.add(item.reviewee_name);
        }

        // Calculate survey status based on item status
        if (item.status === "Training needs identified" || item.status === "Training Needs identified" || item.status === "Failed") {
                    failedCount++;
        } else {
          passedCount++;
        }
      });

      // Calculate average score from questions_scores_summed and max
      this.resultData.data.forEach((item) => {
        if (item.questions_scores_summed && item.max) {
          const currentScore = parseFloat(item.questions_scores_summed) || 0;
          const maxScore = parseFloat(item.max) || 0;

          if (maxScore > 0) {
            const percentage = (currentScore / maxScore) * 100;
            totalScore += percentage;
            scoreCount++;
          }
        }
      });

      const averageScore =
        scoreCount > 0 ? (totalScore / scoreCount).toFixed(1) + "%" : "0%";

      return {
        totalReviewers: uniqueReviewers.size,
        totalReviewees: uniqueReviewees.size,
        totalSurveys:
          this.resultData.total_reviews || this.resultData.data.length || 0,
        averageScore,
        passedCount,
        failedCount,
        pendingCount,
      };
    },
  },
  methods: {
    // Dashboard artık sadece görsellik için - PDF fonksiyonları kaldırıldı
  },
};
</script>

<style lang="scss" scoped>
.dashboard-tab {
  .stat-card {
    background: white;
    padding: 1.5rem;
    border-radius: 8px;
    text-align: center;
    border: 1px solid #e9ecef;
    transition: all 0.2s ease;

    &:hover {
      border-color: #007bff;
      box-shadow: 0 2px 8px rgba(0, 123, 255, 0.1);
    }

    .stat-number {
      font-size: 2rem;
      font-weight: 600;
      color: #495057;
      margin-bottom: 0.5rem;
      line-height: 1;
    }

    .stat-label {
      font-size: 0.875rem;
      color: #6c757d;
      font-weight: 400;
    }
  }

  .chart-container {
    position: relative;
    height: 400px;
    width: 100%;
    background: linear-gradient(135deg, #2c2c2c 0%, #1a1a1a 100%);
    border-radius: 8px;
    padding: 15px;

    canvas {
      max-height: 100% !important;
      height: auto !important;
    }
  }
}
</style>
